import { useState, useRef, useEffect } from "react"

const LeaveApprovalsListController = (onRefresh, leaveApprovalList) => {
    const [isApprovalRejectModalOpen, setIsApprovalRejectModalOpen] = useState(false);
    const approvalRejectInfoRef = useRef(null);
    const [showApproved, setShowApproved] = useState(false);
    // Filtered list
    const filteredList = showApproved
        ? leaveApprovalList?.filter(item => item.leave_status === 2)
        : leaveApprovalList;
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredList?.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentApprovals = filteredList?.slice(indexOfFirstItem, indexOfLastItem);

    const handleApproveRejectClick = (approval) => {
        approvalRejectInfoRef.current = approval;
        setIsApprovalRejectModalOpen(true);
    }

    const handleShowApproved = () => {
        console.log('handleShowApproved showApproved', showApproved)
        setShowApproved(prev => !prev);
        setCurrentPage(1);
        // if (!showApproved) {
        //     console.log('handleShowApproved showApproved if', showApproved)
        //     // Filter Approved Leaves based on the showApproved state
        //     currentApprovals = leaveApprovalList?.filter(approval => approval?.leave_status === 2);
        //     setShowApproved(true);
        // } else {
        //     console.log('handleShowApproved showApproved else', showApproved)
        //     setShowApproved(false);
        //     currentApprovals = leaveApprovalList;
        // }
        // Filter Approved Leaves based on the showApproved state
        // currentApprovals = showApproved ? leaveApprovalList : leaveApprovalList?.filter(approval => approval?.leave_status === 2);
    }

    const [expandedComments, setExpandedComments] = useState({});
    const toggleCommentExpansion = (rowIndex) => {
        setExpandedComments((prev) => ({
          ...prev,
          [rowIndex]: !prev[rowIndex]
        }));
      };

    const [expandedRows, setExpandedRows] = useState({});
    const toggleExpand = (key) => {
        setExpandedRows((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const [daysExpandedRows, setDaysExpandedRows] = useState({});
    const daysToggleExpand = (index) => {
        setDaysExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const [datesExpandedRows, setDatesExpandedRows] = useState({});
    const datesToggleExpand = (index) => {
        setDatesExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const handleCloseModal = () => {
        setIsApprovalRejectModalOpen(false);
    };

    const getStatusStyle = (approval_status_name) => {
        const status = approval_status_name?.toLowerCase();
        switch (status) {
            case "approved":
                return { backgroundColor: "#1A932E2E", color: "#1A932E" };
            case "rejected":
                return { backgroundColor: "#C7C4C32E", color: "#7B7B7B" }; // Gray
            case "approval pending":
                return { backgroundColor: "#EE201C2E", color: "#EE201C" };
            case "partially approved":
                return { backgroundColor: "#fff3cd", color: "#DFA510" }; // Yellow
            // return { backgroundColor: "#E65F2B2E", color: "#E65F2B" };
            default:
                return {};
        }
    };

    const OnAddUpdateSuccess = () => {
        if (onRefresh) {
            onRefresh();
        }
    }

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const maxVisiblePages = 3;

    const getVisiblePages = () => {
        const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust startPage if we're near the end
        const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

        return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
    };

    const visiblePages = getVisiblePages();


    return {
        currentApprovals, approvalRejectInfoRef,
        isApprovalRejectModalOpen,
        handleApproveRejectClick, handleCloseModal,
        getStatusStyle,
        currentPage, totalPages, visiblePages, handlePageChange,
        OnAddUpdateSuccess,
        showApproved, handleShowApproved,
        daysExpandedRows, daysToggleExpand,
        datesExpandedRows, datesToggleExpand,
        expandedRows, toggleExpand,
        expandedComments, toggleCommentExpansion,

    }

}
export default LeaveApprovalsListController;
